import HeaderLarge from './HeaderLarge';

export default HeaderLarge;
